import Modal from "react-modal";
import React, { useEffect, useState } from "react";
import "./Factor.css";
import { useMediaQuery } from "react-responsive";
import { Link } from "react-router-dom";
import AfterLoginNav from "../AfterLoginNav";
import { getUserBalance } from "../../services/balance/index";

export default function Factor({
  modalIsOpen,
  Openchanger,
  data,
  gram,
  soat,
  commodity = 1,
  commodityInfo = [],
  karmozd,
  typeOrder,
  resultChanger,
}) {
  const [userBalance, setUserBalance] = useState(0);
  const [amount, setamount] = useState("");
  const [textId, setTextId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const isSmall = useMediaQuery({ query: "(max-width: 768px)" });
  const [rulAccept, setRulAccept] = useState(true);
  const [diff, setDiff] = useState(0);
  const customStylesDesktop = {
    overlay: {
      position: "fixed",
      zIndex: 1020,
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0, 0.5)",
      display: "flex",
      justifyContent: "center",
    },

    content: {
      background: "#ffffff",
      width: "60rem",
      maxWidth: "calc(150vw - 2rem)",
      maxHeight: "calc(100vh - 2rem)",
      border: "0px",
      overflowY: "auto",
      position: "relative",
      borderRadius: "0.8rem",
      inset: "9px",
    },
  };
  useEffect(() => {
    setRulAccept(true);
  }, []);
  const customStylesMobile = {
    overlay: {
      position: "fixed",
      zIndex: 1020,
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0, 0.5)",
      display: "flex",
      justifyContent: "center",
    },

    content: {
      background: "#ffffff",
      width: "34rem",
      maxWidth: "calc(150vw - 2rem)",
      maxHeight: "calc(95vh - 1rem)",
      overflowY: "auto",
      border: "0px",
      position: "relative",
      borderRadius: "0.4rem",
      inset: "0px",
      margin: "0vh 0px 0px 0px",
    },
  };

  Modal.setAppElement("#root");

  function afterOpenModal() {
    setRulAccept(true);
  }
  function closeModal() {
    Openchanger(false);
    window.location.reload();
  }

  let num;

  function handelchange() {
    resultChanger(data.cash_amount);
  }

  function ex_normalNum(num) {
    num = num.replace(/,\s?/g, "");
    setamount(num);
  }

  function handleSubmit() {
    handelchange();
  }

  function handlechecked(e) {
    setRulAccept(!e.target.checked);
  }

  useEffect(() => {
    if (modalIsOpen) {
      getUserBalance(commodity).then((res) => {
        if (res && res.data && res.data.data) {
          setUserBalance(res.data.data);
          if (typeOrder === "buy") {
            setDiff(res.data.data.cash_balance - Math.abs(data.cash_amount));
          } else {
            setDiff(res.data.data.gold_balance - (gram + soat / 1000));
          }
        }
      });
    }
  }, [modalIsOpen]);

  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        ariaHideApp={false}
        style={isSmall ? customStylesMobile : customStylesDesktop}
        contentLabel="Example Modal"
        backdrop="static"
        id={"factor-modal"}
      >
        <div className="header-modal-wrapper">
          <AfterLoginNav
            title={typeOrder === "buy" ? "پیش فاکتور خرید" : "پیش فاکتور فروش"}
            hasBack={closeModal}
          />
        </div>
        <div className={"container"} id={"factor-mbody"}>
          <div className="remove-cross" onClick={() => Openchanger(false)}>
            &#10006;
          </div>
          <div>
            <div className="factor-wrapper-top">
              <div className="displayff">
                {typeOrder == "buy" ? (
                  <div className="factor-title-right">
                    {`${
                      commodityInfo.length > 0 ? commodityInfo[0].name : ""
                    } درخواستی`}
                  </div>
                ) : (
                  <div className="factor-title-right">
                    مقدار {commodityInfo[0].name}
                  </div>
                )}

                <div className="factor-title-left">
                  {gram > 0 && soat == 0 && (
                    <>
                      {gram} {commodityInfo[0]?.name !== "زرینو" ? "گرم " : ""}
                      {commodityInfo.length > 0 ? commodityInfo[0].name : ""}
                    </>
                  )}

                  {gram == 0 && soat > 0 && (
                    <>
                      {commodityInfo[0].name.indexOf("طلا") >= 0
                        ? soat + " سوت "
                        : ""}
                      {commodityInfo.length > 0 ? commodityInfo[0].name : ""}
                    </>
                  )}

                  {gram > 0 && soat > 0 && (
                    <>
                      {gram} گرم{" "}
                      {commodityInfo[0].name.indexOf("طلا") >= 0 && " و "}
                      {commodityInfo[0].name.indexOf("طلا") >= 0
                        ? soat + " سوت "
                        : ""}
                      {commodityInfo.length > 0 ? commodityInfo[0].name : ""}
                    </>
                  )}
                </div>
              </div>

              <div className="displayff">
                {typeOrder == "buy" ? (
                  <div className="factor-title-right">
                    مبلغ {commodityInfo[0].name} درخواستی
                  </div>
                ) : (
                  <div className="factor-title-right">مبلغ دریافتی</div>
                )}

                <div className="factor-title-left">
                  {data ? (
                    <>
                      {new Intl.NumberFormat("fa", {
                        maximumFractionDigits: 0,
                      }).format(
                        Math.abs(
                          typeOrder === "sell"
                            ? data.cash_amount + data.wage_amount
                            : data.cash_amount + data.wage_amount
                        )
                      )}
                      تومان
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>

              <div className="displayff">
                <div className="factor-title-right">کارمزد طلایی شو</div>

                <div className="factor-title-left">
                  {new Intl.NumberFormat("fa", {
                    maximumFractionDigits: 0,
                  }).format(Math.abs(data.wage_amount))}
                  {" تومان "}
                </div>
              </div>

              <div className="final-factor-amount">
                <div className="desktop-wrapper-final-amount">
                  {typeOrder == "buy" ? (
                    <div className="title-for-factor-amount">قابل پرداخت</div>
                  ) : (
                    <div className="title-for-factor-amount">
                      مبلغی که دریافت میکنید
                    </div>
                  )}

                  <div className="number-for-factor-final">
                    {new Intl.NumberFormat("fa", {
                      maximumFractionDigits: 0,
                    }).format(Math.abs(data.cash_amount))}
                    {" تومان "}
                  </div>
                </div>
              </div>
            </div>

            <div>
              {diff < 0 ? (
                <>
                  <div className="low-balance">
                    {typeOrder === "buy" ? (
                      <>
                        موجودی کیف پول برای خرید کافی نیست، لطفاً موجودی را
                        افزایش دهید.
                      </>
                    ) : (
                      <>
                        {"موجودی " +
                          commodityInfo[0].name +
                          " شما کافی نیست، آن را افزایش دهید"}
                      </>
                    )}
                  </div>
                </>
              ) : (
                <></>
              )}
              <div className="existing-wallet-balance">
                {typeOrder == "buy" ? (
                  <>
                    <div className="title-existing-wallet-balance">
                      موجودی فعلی
                    </div>

                    <div className="amount-existing-wallet-balance">
                      {typeOrder == "buy" ? (
                        <>
                          {new Intl.NumberFormat("fa", {
                            maximumFractionDigits: 0,
                          }).format(userBalance.cash_balance)}
                          {" تومان "}
                        </>
                      ) : (
                        <>
                          {new Intl.NumberFormat("fa", {
                            maximumFractionDigits: 0,
                          }).format(userBalance.gold_balance)}
                          {" گرم "}
                        </>
                      )}
                    </div>
                    {diff < 0 && (
                      <div className="diff-amount">
                        <div className="title-existing-wallet-balance">
                          مبلغ مورد نیاز
                        </div>

                        <div className="amount-existing-wallet-balance">
                          {typeOrder == "buy" ? (
                            <>
                              {new Intl.NumberFormat("fa", {
                                maximumFractionDigits: 0,
                              }).format(Math.abs(diff))}
                              {" تومان "}
                            </>
                          ) : (
                            <>
                              {new Intl.NumberFormat("fa", {
                                maximumFractionDigits: 0,
                              }).format(Math.abs(diff))}
                              {" گرم "}
                            </>
                          )}
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    <div className="title-existing-wallet-balance">
                      موجودی {commodityInfo[0].name} شما
                    </div>

                    <div className="amount-existing-wallet-balance">
                      {new Intl.NumberFormat("fa", {
                        maximumFractionDigits: 0,
                      }).format(userBalance.gold_balance)}
                      {" گرم "}
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className="rules-on-modal">
              <input
                type="checkbox"
                id="vehicle1"
                name="vehicle1"
                value="Bike"
                className="ml-3"
                onClick={handlechecked}
              />
              <div className="d-flex tit5060">
                اینجانب تمام{" "}
                <Link to={"/info?state=ruls"} className="kjfsfewrulesss">
                  قوانین
                </Link>{" "}
                طلایی شو را می پذیریم.
              </div>
              <br />
            </div>

            <div>
              {typeOrder == "buy" ? (
                <div className="buttons-wrapper-modal">
                  {diff > 0 ? (
                    <button
                      type="button"
                      className="form-input-button-custom"
                      onClick={handleSubmit}
                      disabled={rulAccept}
                    >
                      {isLoading ? (
                        <img
                          src={"./loading.svg"}
                          alt={""}
                          className={"w-loading"}
                        />
                      ) : (
                        <>پرداخت از کیف پول</>
                      )}
                    </button>
                  ) : (
                    <Link to={"/deposit"}>
                      <button
                        className="form-input-button-custom"
                        disabled={rulAccept}
                      >
                        {isLoading ? (
                          <img
                            src={"./loading.svg"}
                            alt={""}
                            className={"w-loading"}
                          />
                        ) : (
                          <>پرداخت</>
                        )}
                      </button>
                    </Link>
                  )}
                </div>
              ) : (
                <div className="buttons-wrapper-modal">
                  <button
                    type="button"
                    className="form-input-button-custom"
                    onClick={handleSubmit}
                    disabled={rulAccept}
                  >
                    {isLoading ? (
                      <img
                        src={"./loading.svg"}
                        alt={""}
                        className={"w-loading"}
                      />
                    ) : (
                      <>ثبت فروش</>
                    )}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}
